import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BaseClient } from '../BaseClient';
export class PulseClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "triggerPulseImpl", void 0);
  }
  getServiceNameForLogs() {
    return 'PulseClient';
  }
  async triggerPulse(pulseIdentityId) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      await this.request(this.triggerPulseImpl({
        pulseIdentityId
      }), ...args);
    } catch (error) {
      this.logError('triggerPulse', 'Failed to trigger pulse', {
        pulseIdentityId
      }, error);
      throw error;
    }
  }
  convertToEntity() {
    throw new Error('PulseClient does not produce an entity');
  }
}
//# sourceMappingURL=PulseClientBase.js.map